import { useAuth } from '@nemuru-eng/providers';

import { HomeHeader } from '@/components/shared/components/HomeHeader';
import { HomeShortcuts } from '@/components/shared/components/HomeShortcuts/HomeShortcuts';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

import { useConfigContext } from '../../contexts/ConfigContext/ConfigContext';

const HomeNav = () => {
  const {
    state: { currentLayout },
  } = useConfigContext();

  const { user } = useAuth();

  const navSections = currentLayout?.navSections;

  if (!currentLayout || !navSections || !user) return null;

  return (
    <>
      <HomeHeader username={user.username} />

      <HomeShortcuts />
    </>
  );
};

export const HomeNavModule = withPermissionsModule(HomeNav);
